angular.module('impactx.basket').directive('basketTemplateMenu', function()
{
    return {
        template:'<ng-transclude-replace></ng-transclude-replace>',
        transclude: true,
        controller: 'BasketTemplateMenuCtrl',
        controllerAs: 'basketTemplateMenuCtrl'
    }
});